import React from 'react';
import classnames from 'classnames';

import './style.scss';

export interface IAttachmentImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  alt: string;
}

const AttachmentImage: React.FC<IAttachmentImageProps> = ({ alt, className, onClick, src, ...imgProps }) => {
  const [hasLoadError, setHasLoadError] = React.useState(false);
  const placeholderClassName = classnames(className, 'attachment-image-placeholder');

  React.useEffect(() => {
    setHasLoadError(false);
  }, [src]);

  if (hasLoadError) {
    const placeholderIcon = <img src="/assets/no-image.svg" alt="" className="attachment-image-placeholder__icon" />;

    return onClick ? (
      <button
        type="button"
        className={placeholderClassName}
        aria-label={`${alt} unavailable`}
        onClick={onClick as unknown as React.MouseEventHandler<HTMLButtonElement>}
      >
        {placeholderIcon}
      </button>
    ) : (
      <div className={placeholderClassName} role="img" aria-label={`${alt} unavailable`}>
        {placeholderIcon}
      </div>
    );
  }

  return (
    <img
      {...imgProps}
      className={className}
      src={src}
      alt={alt}
      onClick={onClick}
      onError={() => setHasLoadError(true)}
    />
  );
};

export default AttachmentImage;
